import * as contentful from 'contentful'
import CONFIG from '../config'

const contentfulClient = contentful.createClient({
  space: CONFIG.CONTENTFUL.SPACE,
  accessToken: CONFIG.CONTENTFUL.ACCESS_TOKEN,
})

export const getContent = async () => await contentfulClient.getEntry(CONFIG.CONTENTFUL.ENTRY_ID)
export const getTeamContent = async () =>
  await contentfulClient.getEntry(process.env.TEAM_ENTRY_ID || CONFIG.CONTENTFUL.TEAM_ENTRY_ID)

export default contentfulClient
